import { useMemo } from "react"

import { useExtension } from "hooks/extension/useExtension"
import { useVenue } from "providers/venue"
import { get } from "lodash"
import { EXTENSION_NAME } from "../constant"

export const useHome = () => {
  const { dataLoaded } = useVenue()
  const { extensionConfig } = useExtension()

  const navigations = useMemo(
    () => get(extensionConfig, `${EXTENSION_NAME}.options.navigations`, []),
    [extensionConfig]
  )

  return {
    navigations,
    dataLoaded,
  }
}
